export default class UnderwritingDecision {
  static Status = {
    APPROVED: 'approved',
    DECLINED: 'declined',
    UNDECIDED: 'undecided',
    PENDING: 'pending',
  }
}
